import { render, staticRenderFns } from "./CompensationHRM.vue?vue&type=template&id=28d1d0a2&"
import script from "./CompensationHRM.vue?vue&type=script&lang=js&"
export * from "./CompensationHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports